import daAuth from "../locales/da/auth.json";
import daCalendar from "../locales/da/calendar.json";
import daCommon from "../locales/da/common.json";
import daErrors from "../locales/da/errors.json";
import daNetwork from "../locales/da/network.json";
import daNotifications from "../locales/da/notifications.json";
import daSettings from "../locales/da/settings.json";
import daShop from "../locales/da/shop.json";
import enAuth from "../locales/en/auth.json";
import enCalendar from "../locales/en/calendar.json";
import enCommon from "../locales/en/common.json";
import enErrors from "../locales/en/errors.json";
import enNetwork from "../locales/en/network.json";
import enNotifications from "../locales/en/notifications.json";
import enSettings from "../locales/en/settings.json";
import enShop from "../locales/en/shop.json";
import fiAuth from "../locales/fi/auth.json";
import fiCalendar from "../locales/fi/calendar.json";
import fiCommon from "../locales/fi/common.json";
import fiErrors from "../locales/fi/errors.json";
import fiNetwork from "../locales/fi/network.json";
import fiNotifications from "../locales/fi/notifications.json";
import fiSettings from "../locales/fi/settings.json";
import fiShop from "../locales/fi/shop.json";
import noAuth from "../locales/no/auth.json";
import noCalendar from "../locales/no/calendar.json";
import noCommon from "../locales/no/common.json";
import noErrors from "../locales/no/errors.json";
import noNetwork from "../locales/no/network.json";
import noNotifications from "../locales/no/notifications.json";
import noSettings from "../locales/no/settings.json";
import noShop from "../locales/no/shop.json";
import svAuth from "../locales/sv/auth.json";
import svCalendar from "../locales/sv/calendar.json";
import svCommon from "../locales/sv/common.json";
import svErrors from "../locales/sv/errors.json";
import svNetwork from "../locales/sv/network.json";
import svNotifications from "../locales/sv/notifications.json";
import svSettings from "../locales/sv/settings.json";
import svShop from "../locales/sv/shop.json";
import type { Locale } from "../locales.ts";
import { type AreaCatalog, createTranslator, mergeAreas } from "../translator.ts";

/**
 * The staff app: calendar, franchise admin and the HQ dashboard.

 * No `booking.*` or `email.*`: the public flow is a separate app, and the email strings are
 * rendered by the worker.
 */

const catalogs: Readonly<Record<Locale, AreaCatalog>> = {
  sv: mergeAreas([
    svCommon,
    svErrors,
    svCalendar,
    svSettings,
    svAuth,
    svNetwork,
    svNotifications,
    svShop,
  ]),
  no: mergeAreas([
    noCommon,
    noErrors,
    noCalendar,
    noSettings,
    noAuth,
    noNetwork,
    noNotifications,
    noShop,
  ]),
  en: mergeAreas([
    enCommon,
    enErrors,
    enCalendar,
    enSettings,
    enAuth,
    enNetwork,
    enNotifications,
    enShop,
  ]),
  da: mergeAreas([
    daCommon,
    daErrors,
    daCalendar,
    daSettings,
    daAuth,
    daNetwork,
    daNotifications,
    daShop,
  ]),
  fi: mergeAreas([
    fiCommon,
    fiErrors,
    fiCalendar,
    fiSettings,
    fiAuth,
    fiNetwork,
    fiNotifications,
    fiShop,
  ]),
};

export const { t, plural } = createTranslator(catalogs);
